const CustomizedFormGroupTitle = (props) => {
    const {
        label
    } = props

    return <div className="form-group">
        <h1>{label}</h1>
    </div>
}

export default CustomizedFormGroupTitle;